module.exports = __webpack_public_path__ + "static/media/Motorbike.a67245cb.svg";